module.exports = __webpack_public_path__ + "img/Final Model V1.8cd25ff0.jpg";